import React, { useEffect, useState } from "react";
import { ErrorMsg, InfoIcon, sessionUser } from "../../Util/common";
import { ImageURL } from "../../Util/axios_core_helper";
import { KendoLoader } from "../../Kendo/kendo_loader";
import { toast } from "react-toastify";

export const LayoutForm = ({
  facilityDetails,
  setFacilityDetails,
  goNext,
  goBack,
  handleSubmit,
  Loading,
}) => {
  const [LayoutForm, setLayoutForm] = useState({
    Layout_ID: 0,
    FacilityID: 0,
    Images: "",
    OldImagePath: "",
  });
  const [imageList, setImageList] = useState([]);
  const [error, setError] = useState({});
  const [editVisible, setEditVisible] = useState(false);

  // Initialize imageList and LayoutForm for editing
  useEffect(() => {
    if (facilityDetails && facilityDetails.Layout) {
      const existingImages = facilityDetails.Layout.map((layout) => ({
        Layout_ID: layout.layout_ID || 0,
        FacilityID:
          layout.facilityID || facilityDetails?.FacilityForm?.FacilityID || 0,
        imagePath: layout.oldImagePath
          ? `${ImageURL}/${layout.oldImagePath}`
          : "",
        fileName: layout.FileName || "",
        OldImagePath: layout.oldImagePath,
        SavedBy: layout.SavedBy || 123,
      }));

      setImageList(existingImages);
      setLayoutForm({
        Layout_ID: 0,
        FacilityID: facilityDetails?.FacilityForm?.FacilityID || 0,
        Images: "",
        OldImagePath: "",
      });
    }
  }, [facilityDetails]);

  const clearForm = () => {
    setLayoutForm({
      Layout_ID: 0,
      FacilityID: 0,
      Images: "",
      OldImagePath: "",
    });
    setError({});
    setEditVisible(false);
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = null;
    }

    const form = document.getElementById("form-culture-config");
    if (form) {
      form.reset();
    }
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    const validImages = files.filter((file) => file.type.startsWith("image/"));
    const hasAvifFile = files.some(
      (file) => file.type === "image/avif" || file.name.endsWith(".avif")
    );

    if (hasAvifFile) {
      toast.error("Uploaded images contain unsupported formats.");
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
      return;
    }
    if (validImages.length !== files.length) {
      setError({ ValidFile: true });
    } else {
      const newImageList = validImages.map((file, index) => ({
        Layout_ID: 0,
        FacilityID: facilityDetails?.FacilityForm?.FacilityID || 0,
        Image: file,
        fileData: file,
        imagePath: URL.createObjectURL(file),

        fileName: file.name,
        SavedBy: sessionUser(),
        OldImagePath: "",
      }));
      $("#lFile").val("");
      setError({ ValidFile: false });
      setImageList((prevImages) => [...prevImages, ...newImageList]);

      setLayoutForm((prevState) => ({
        ...prevState,
        Images: prevState.Images
          ? [...prevState.Images, ...validImages]
          : [...validImages],
      }));
      // setFacilityDetails((prev) => ({
      //   ...prev,
      //   Layout: newImageList,
      // }));
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (imageList.length == 0) {
      setError({ Images: true });
      return;
    }

    setError({});

    setFacilityDetails((prev) => ({
      ...prev,
      Layout: imageList,
    }));

    handleSubmit(e, imageList, removedImageIds);
  };
  const [removedImageIds, setRemovedImageIds] = useState();

  const handleRemoveImage = (Layout_ID, index) => {
    const updatedImageList = imageList?.filter((_, i) => i !== index);
    setImageList(updatedImageList);

    setRemovedImageIds((prevRemovedIds = "") =>
      [...prevRemovedIds.split(","), Layout_ID].join(",")
    );

    setLayoutForm((prevForm) => ({
      ...prevForm,
      Images: updatedImageList,
    }));
  };

  return (
    <div>
      {/* File Input */}
      <div className="col-md-4 mb-3">
        <label className="form-label">
          Upload Image <span className="text-danger">*</span>
          <InfoIcon
            content="Please ensure each image is uploaded within a maximum size of 500KB,
          Please upload the images in JPEG or JPG format."
          />
        </label>
        <input
          id="lFile"
          className="form-control"
          type="file"
          name="File"
          accept="image/*"
          multiple
          onChange={handleFileChange}
        />
        {error.Images && <ErrorMsg text=" Image is required" />}
        {error.ValidFile && <ErrorMsg text="please upload Image file only" />}
      </div>

      {/* Image Previews */}
      <div className="d-flex flex-wrap gap-3 mt-3">
        {imageList.length > 0 &&
          imageList.map((image, index) => (
            <div
              key={index}
              className="d-flex flex-column align-items-center"
              style={{
                position: "relative", // Parent div needs relative positioning
                width: "100px",
                height: "100px",
              }}
            >
              <img
                src={image.imagePath}
                alt={"Uploading"}
                className="add-default-loading"
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                }}
              />
              {/* Cross Mark Button */}
              <button
                style={{
                  position: "absolute",
                  top: "-10px",
                  right: "-10px",
                  background: "red",
                  color: "white",
                  border: "none",
                  borderRadius: "50%",
                  fontSize: "14px",
                  width: "20px",
                  height: "20px",
                  cursor: "pointer",
                }}
                className="close"
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveImage(image.Layout_ID, index);
                }}
              >
                ×
              </button>
            </div>
          ))}
      </div>
      {Loading ? (
        <KendoLoader className="d-flex justify-content-end align-items-center" />
      ) : (
        <div className="col-md-12 mb-3" style={{ textAlign: "right" }}>
          <button
            type="submit"
            className="butn-dark2 grey-btn m-2"
            onClick={goBack}
          >
            <span>Back</span>
          </button>
          <button type="submit" className="butn-dark2" onClick={onSubmit}>
            <span> Submit</span>
          </button>
        </div>
      )}
    </div>
  );
};
